import { ModuleSettings } from './module-settings.do';


/**
 * Module settings ValueSchema: SalesOrganizationSettings v1.
 */
export class SalesOrganizationSettings extends ModuleSettings {
  /**
   * VAT number(this is a number given to the Organization by the taxation authority).
   */
  VAT: string;

  /**
   * Address line 1.
   */
  AddressLine1: string;

  /**
   * Address line 2.
   */
  AddressLine2: string;

  /**
   * Address line 3.
   */
  AddressLine3: string;

  /**
   * Address City.
   */
  City: string;

  /**
   * Address Country.
   */
  Country: string;

  /**
   * Zip.
   */
  Zip: string;

  /**
   * SSN number.
   */
  SSN: string;

  /**
   * Invoice / Sales Contact email address.
   */
  Email: string;

  /**
   * Phone number.
   */
  PhoneNumber: string;

  /**
   * Invoice / Sales Contact mobile number.
   */
  MobileNumber: string;

  /**
   * Invoice / Sales Contact fax number.
   */
  FaxNumber: string;

  /**
   * Bank Info: IBAN.
   */
  BankIBAN: string;

  /**
   * Bank info: SWIFT
   */
  BankSwift: string;

  /**
   * CurrencyCode.
   */
  CurrencyCode: string;

  /**
   * Sales Organization name.
   */
  Name: string;

  /**
   * Sales Organization VAT number.
   */
  VATNumber: string;

  /**
   * Contact URL.
   */
  Url: string;
}
